// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".grid h2.subheadline{font-size:1.625rem;margin-bottom:30px;margin-top:10px;padding:0 10px;text-align:center;word-break:break-word}@media screen and (min-width:767px){.grid h2.subheadline{font-size:2.625rem;margin-bottom:60px;margin-top:20px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
